import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AuthService from 'services/AuthService';

import {
  getError,
  getUserId,
  isAuthed,
  isLoading,
  logout,
} from 'redux/modules/auth/status';

import {
  beginSMSChallenge,
  getActivationCode,
  getChallengeID,
  getStep,
  getTryCount,
  resolveSMSChallenge,
} from 'redux/modules/auth/sms';

const auth = new AuthService();

export const WithAuth = (props) => {
  const { wrappedComponent: WrappedComponent, ...rest } = props;

  useEffect(() => {
    props.isAuthed && auth.onLogout(props.logout);
  }, [props.isAuthed, props.logout]);

  return <WrappedComponent {...rest} />;
};

WithAuth.propTypes = {
  isAuthed: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  wrappedComponent: PropTypes.any.isRequired,
};

export default (WrappedComponent) => {
  const mapStateToProps = (state) => ({
    isAuthed: isAuthed(state),
    isLoading: isLoading(state),
    activationCode: getActivationCode(state),
    challengeID: getChallengeID(state),
    error: getError(state),
    SMSStep: getStep(state),
    SMSTryCount: getTryCount(state),
    userId: getUserId(state),
    wrappedComponent: WrappedComponent,
  });

  return withRouter(
    connect(mapStateToProps, {
      beginSMSChallenge,
      logout,
      resolveSMSChallenge,
    })(WithAuth),
  );
};
